import { render } from "./AccessGroup.vue?vue&type=template&id=3bb39e05&scoped=true"
import script from "./AccessGroup.vue?vue&type=script&lang=js"
export * from "./AccessGroup.vue?vue&type=script&lang=js"

import "./AccessGroup.vue?vue&type=style&index=0&id=3bb39e05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb39e05"]])

export default __exports__